export default "__VITE_ASSET__EsZqAxtl__"